import { Component } from '@angular/core';


@Component({
    selector: 'app-page-mananagement',
    templateUrl: './management.component.html'
})
export class ManagementComponent  {
}
